import React from "react";
import classNames from "classnames";
import { Icomoon, Icon } from "../../brand";
import "./ItinerarySection.scss";

interface Props {
  /**
   * Title for the section.
   */
  title: string;

  /**
   * Icon to display next to the title on mobile.
   */
  icomoon: Icomoon;

  className?: string;
}

/**
 * Wrapper component for itineray sections.
 * 
 * @status development
 */
export const ItinerarySection: React.FC<Props> = ({
  title,
  className,
  icomoon,
  children
}) => {
  return (
    <div className={classNames("itinerary-section", className)}>
      <h2><Icon className="is-hidden-tablet itinerary-section__icon" icomoon={icomoon} /> {title}</h2>

      {children}
    </div>
  );
}
